import React from "react";
import {connect} from "react-redux";
import Rdx from "../../../../../redux/Rdx";
import Context from "../../../../../context/Context";
import moment from "moment";
import Icons from "../../../../util/Icons";
import Button from "../../../../../common/components/Button";
import DayToggle from "./DayToggle";
import { TimePicker } from "antd";
import Popover from "calcite-react/Popover"
import SDPWrapper from "../../../../common/Calendar/SDPWrapper";
import Topic from "../../../../../context/Topic";
import * as component from "../../../../util/component";

const CSS = {
  popoutInner: "i-popout-inner i-booking-details-popup",
  popoutOuter: "i-popout-outer",
  panelHeader: "i-infopanel-header i-panel-header",
  panelHeaderTools: "i-panel-header-tools",
  filterForm: "i-filter-form",
  toggleAllDay: "i-toggle-all-day",
  toggleLabel: "i-toggle-label",
  durationFilter: "i-duration-filter",
  durationFilterForm: "i-duration-filter-form",
  durationGroup: "i-duration-group",
  durationDate: "i-date",
  durationTime: "i-time",
  iconContainer: "i-sidebar-icon-container i-filter-container",
  icon: "i-more-menu-icon",
  spaceFilters: "i-space-filter",
  button: "i-book-button",
  dateString: "i-date-string",
  confirmButton: "i-book-confirm",
  bookingFields: "i-booking-fields",
  bookingDetails: "i-booking-details",
  bookingDetailsTitle: "i-booking-details-title"
};

class BookingDetails extends React.Component {
  format
  use12Hours

  constructor(props) {
    super(props);
    this.closeRef = React.createRef();
    const locale = Context.instance.lib.dojo.kernel.locale
    if (locale === "en" || locale === "en-us") {
      this.use12Hours = true
      this.format = "h:mm A"
    } else {
      this.use12Hours = false
      this.format = "H:mm"
    }
    let startDate, endDate, startTime, endTime, allDay;
    if(this.props.isBookWorkspacePanel ){
      startDate = this.props.rdxStartDateSelected;
      endDate = this.props.rdxEndDateSelected;
      startTime = this.props.rdxStartTimeSelected;
      endTime = this.props.rdxEndTimeSelected;
      allDay = this.props.rdxAllDayChecked;
    }else{
      startDate = new Date();
      endDate = new Date();
      startTime = this.getDefaultStartTime();
      endTime = this.getDefaultEndTime();
      allDay = false
    }

    this.state = component.newState({
        startDate : startDate,
        endDate : endDate,
        startTime : startTime,
        endTime : endTime,
        startCalendarOpen: false,
        endCalendarOpen: false,
        allDay: allDay,
        toggleFocused: false
    })
  }

  returnClicked(event) {
    if (event.keyCode === 13) {
      Topic.publish(Topic.ToggleReturnClicked, {})
    }
  }

  init=()=> {
    let startDate, endDate, startTime, endTime;
    if(this.props.isBookWorkspacePanel ){
      startDate = this.props.rdxStartDateSelected;
      endDate = this.props.rdxEndDateSelected;
      startTime = this.props.rdxStartTimeSelected;
      endTime = this.props.rdxEndTimeSelected;
    }else{
      startDate = moment();
      endDate = moment();
      startTime = this.getDefaultStartTime();
      endTime = this.getDefaultEndTime();
    }
    this.setState({
      startDate: startDate,
      endDate: endDate,
      startTime: startTime,
      endTime: endTime
    })
  }

  getDefaultStartTime =()=> {
    var m = moment();
    const remainder = 30 - (m.minute() % 30);
    var roundUp = moment(m).add(remainder, "minutes");
    return (moment(roundUp));
  }

  getDefaultEndTime =()=> {
    var startTime = this.getDefaultStartTime();
    return (moment(startTime).add(1,'hours'));
  }

  getValidEndTime =()=> {
    var startTime = this.state.startTime;
    return (moment(startTime).add(1, 'hours'));
  }

  componentDidMount() {
    if (this.closeRef && this.closeRef.current && this.closeRef.current.focus) {
      this.closeRef.current.focus()
    }
    document.addEventListener("keyup", this.returnClicked, false)
    component.own(this, [
      Topic.subscribe(Topic.ToggleReturnClicked, params => {
        if (this.state.toggleFocused) {
          this.setState({
            allDay: !this.state.allDay
          })
        }
      })
    ])
  }

  componentDidUpdate() {
    const clockIcons = document.getElementsByClassName("ant-picker-suffix")
    for (let i = 0; i < clockIcons.length; i++) {
      clockIcons[i].setAttribute("aria-hidden", "true")
    }
    // const timeInputs = document.getElementsByClassName("ant-picker-input")
    // for (let i = 0; i < timeInputs.length; i++) {
    //   timeInputs[i].setAttribute("aria-hidden", "true")
    // }
    // const focusedTime = document.getElementsByClassName("ant-picker")
    // for (let i = 0; i < focusedTime.length; i++) {
    //   focusedTime[i].setAttribute("tabIndex", "0")
    //   focusedTime[i].setAttribute("role", "button")
    // }
    const cells = document.getElementsByClassName("ant-picker-time-panel-cell")
    for (let i = 0; i < cells.length; i++) {
      cells[i].setAttribute("tabIndex", "0")
    }
    const panel = document.getElementsByClassName("ant-picker-panel")
    for (let i = 0; i < panel.length; i++) {
      panel[i].setAttribute("tabIndex", "0")
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.returnClicked, false)
    component.componentWillUnmount(this)
  }

  confirmClicked=()=>{
    let checkInDate = this.makeStartDateTime();
    let checkOutDate = this.makeEndDateTime();
    this.props.checkAvailability(checkInDate, checkOutDate);
    this.props.closePopup();
  }
  
  getEpochCurrentTime =()=> {
    const currentDateTime = new Date();
    var unix_seconds = (new Date(currentDateTime)).getTime();
    return unix_seconds; 
  }

  getEpochEndTime =()=> {
    let endDateTime = this.makeEndDateTime();
    var unix_seconds = (new Date(endDateTime)).getTime();
    return unix_seconds; 
  }

  getEpochStartTime =()=> {
    let startDateTime = this.makeStartDateTime();
    var unix_seconds = (new Date(startDateTime)).getTime();
    return unix_seconds;
  }

  makeEndDateTime = () => {
    const lib = Context.instance.lib
    const allDay = this.state.allDay
    let endDate = lib.dojo.locale.format(this.state.endDate, {
      selector: "date",
      datePattern: "yyyy/MM/dd"
    })
    const endTime = this.state.endTime;
    let hour = endTime.hour()
    if (hour < 10) hour = "0" + hour
    let minute = endTime.minute()
    if (minute < 10) minute = "0" + minute
    // let second = endTime.seconds()
    // if (second < 10) second = "0" + second
    let time = hour + ":" + minute + ":00";
    if (allDay) {
      let nextDay = new Date(this.state.endDate)
      nextDay.setDate(this.state.endDate.getDate() + 1)
      endDate = lib.dojo.locale.format(nextDay, {
        selector: "date",
        datePattern: "yyyy/MM/dd"
      })
      time = "00:00:00"
    }

    const checkOutDate1 = endDate + ' '+ time;
    //const checkOutDate = new Date(checkOutDate1).toISOString();
    const checkOutDate = new Date(checkOutDate1);
    return checkOutDate;
  }

  makeStartDateTime= () => {
    const lib = Context.instance.lib
    const startTime = this.state.startTime;
    const allDay = this.state.allDay
    let startDate = lib.dojo.locale.format(this.state.startDate, {
      selector: "date",
      datePattern: "yyyy/MM/dd"
    })
    let hour = startTime.hour()
    if (hour < 10) hour = "0" + hour
    let minute = startTime.minute()
    if (minute < 10) minute = "0" + minute
    // let second = startTime.seconds()
    // if (second < 10) second = "0" + second
    let time = hour + ":" + minute + ":00";
    // const checkInDate = startDate + "T" + time;
    if (allDay) {
      time = "00:00:00"
    }
    const checkInDate1 = startDate + ' '+ time;
    //const checkInDate = new Date(checkInDate1).toISOString();
    const checkInDate = new Date(checkInDate1);
    return checkInDate;
  }

  allDayChanged = (checked) => {
    this.setState({
      allDay: checked
    })
  }

  makeValidations =()=> {
    if(this.getEpochEndTime() <= this.getEpochStartTime() || this.getEpochStartTime() < this.getEpochCurrentTime()){
      if(this.getEpochStartTime() < this.getEpochCurrentTime()){
        this.setState({
          startTime : this.getDefaultStartTime(),
          endTime : this.getDefaultEndTime()
        })
      }
      if(this.getEpochEndTime() <= this.getEpochStartTime()){
        this.setState({
          endTime: this.getValidEndTime()
        })
      }
      if(this.state.startDate > this.state.endDate){
        this.setState({
          endDate : this.state.startDate
        })
      }
    }
  }

  equalDates = (date1, date2) => {
    const matchingDays = date1.getDate() === date2.getDate()
    const matchingMonths = date1.getMonth() === date2.getMonth()
    const matchingYears = date1.getFullYear() === date2.getFullYear()
    return matchingDays && matchingMonths && matchingYears
  }

  onEndTimeChange = (time) => {
    const checkIn = this.state.startDate
    const checkOut = this.state.endDate
    if (time && time !== undefined) {
      if (this.equalDates(checkIn, checkOut)) {
        if (time.isSame(this.state.startTime, "hour")) {
          const startMin = this.state.startTime.minute()
          const endMin = time.minute()
          const diff = endMin - startMin
          if (diff >= 30) {
            this.setState({
              endTime: time
            },()=>{
              this.makeValidations();
            })
          }
        } else if (time.isAfter(this.state.startTime, "hour")) {
          const startMin = this.state.startTime.minute();
          const endMin = time.minute() + 60;
          const diff = endMin - startMin;
          if (diff >= 30) {
            this.setState({
              endTime: time
            },()=>{
              this.makeValidations();
            })
          }
        }
      } else {
        this.setState({
          endTime: time
        })
      }
    }
  }

  onStartTimeChange = (time) => {
    const checkIn = this.state.startDate
    const checkOut = this.state.endDate
    if (time && time !== undefined) {
      if (this.equalDates(checkIn, checkOut)) {
        let endTime = this.state.endTime
        if (time.isSame(endTime)) {
          endTime = moment(time).add(1, "hour")
        } else {
          if (time.isAfter(endTime)) {
            endTime = moment(time).add(1, "hour")
          } else {
            if (time.isSame(endTime, "hour")) {
              const endMin = endTime.minute()
              const startMin = time.minute()
              const diff = endMin - startMin
              if (diff <= 30) {
                endTime = moment(endTime).add(30 - diff, "minute")
              }
            } else {
              const endMin = endTime.minute() + 60
              const startMin = time.minute()
              const diff = Math.abs(endMin - startMin)
              if (diff <= 30) {
                endTime = moment(endTime).add(30 - diff, "minute")
              }
            }
          }
        }
        this.setState({
          startTime: time,
          endTime: endTime
        },()=>{
          this.makeValidations();
        })
      } else {
        this.setState({
          startTime: time
        })
      }
    }
  }

  onEndDateChanged = (date) => {
    this.setState({
      endDate : date,
      endCalendarOpen: false
    }, ()=>{
      this.makeValidations();
    });
  }

  onStartDateChanged = (date) => {
    this.setState({
        startDate : date,
        startCalendarOpen: false
    },()=>{
      this.makeValidations();
    });
  }

  onToggleFocus = () => {
    this.setState({
      toggleFocused: true
    })
  }

  onToggleBlur = () => {
    this.setState({
      toggleFocused: false
    })
  }

  render() {
    const i18n = Context.instance.i18n;
    const lib = Context.instance.lib

    const calendarIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#calendar-16";

    const startDate = lib.dojo.locale.format(this.state.startDate, { selector:"date", formatLength:"short" })
    const endDate = lib.dojo.locale.format(this.state.endDate, { selector:"date", formatLength:"short" })

    const startTime = this.state.startTime;
    const endTime = this.state.endTime;
    let title = i18n.more.bookWorkspace.bookingDetailsTitle;
    title = title.replace("{levelName}", this.props.levelName);
    title = title.replace("{buildingName}", this.props.facilityName);
    const checked = this.state.allDay || ''

    const checkInDateLabel = startDate + ", " + i18n.more.bookWorkspace.startCalendarAriaLabel
    const checkOutDateLabel = endDate + ", " + i18n.more.bookWorkspace.endCalendarAriaLabel

    const startDateButton = (
      <button aria-label={checkInDateLabel} 
        className={CSS.durationDate} onClick={this.togglePopoverStart}>
        <div className={CSS.iconContainer}>
          <div className={CSS.dateString}>{startDate}</div>
          <svg className={CSS.icon}><use href={calendarIcon}></use></svg>
        </div>
      </button>
    )
    const endDateButton = (
      <button aria-label={checkOutDateLabel} 
        className={CSS.durationDate} onClick={this.togglePopoverEnd}>
        <div className={CSS.iconContainer}>
          <div className={CSS.dateString}>{endDate}</div>
          <svg className={CSS.icon}><use href={calendarIcon}></use></svg>
        </div>
      </button>
    )
    const isOutsideRange = (day) => moment().isAfter(day, 'day')
    const isDayHighlightedStart = (day) => {
      const start = moment(this.state.startDate)
      return moment().isSame(day, 'day') && !start.isSame(day, 'day')
    }
    const isDayHighlightedEnd = (day) => {
      const end = moment(this.state.endDate)
      return moment().isSame(day, 'day') && !end.isSame(day, 'day')
    }

    const onOpenChange = (open) => {
      if (open) {
        const preventScroll = () => {
          const timeColumns = document.getElementsByClassName("ant-picker-time-panel-column")
          for (var i = 0; i < timeColumns.length; i++) {
            const text = timeColumns[i].firstChild.firstChild.innerText
            if (text === "AM" || text === "PM") {
              timeColumns[i].style.overflowY = "visible"
            }
          }
        }
        setTimeout(preventScroll, 100)
      }
    }

    const checkInTimeLabel = "Check in time"
    const checkOutTimeLabel = "Check out time"
    return (
    <div className={CSS.popoutOuter}>
    <div className={CSS.popoutInner}>
        <div className={CSS.panelHeader}>
          <div className={CSS.bookingDetailsTitle}>
            <h2>{this.props.unitName}</h2>
            <h4>{title}</h4>
          </div>

        <div className={CSS.panelHeaderTools}>
            <button ref={this.closeRef}
            title={i18n.general.close} aria-label={i18n.infoPanel.closeAriaLabel}
            tabIndex="0" onClick={this.props.closePopup}>
            {Icons.close()}
            </button>
        </div>
        </div>
        <div className={CSS.filterForm}>
        <div className={CSS.toggleAllDay}>
          <label for={"allDay"} className={CSS.toggleLabel}>{i18n.more.bookWorkspace.allDay}</label>
          <DayToggle id={"allDay"} checked={checked} onChange={this.allDayChanged}
              ariaLabel={i18n.more.bookWorkspace.toggleAriaLabel}
              onToggleFocus={this.onToggleFocus} 
              onToggleBlur={this.onToggleBlur}></DayToggle>
        </div>
        <div className={CSS.bookingFields}>{i18n.more.bookWorkspace.checkIn}</div>
        <div className={CSS.durationGroup}>
          <Popover
            closeOnSelect={false}
            onRequestClose={this.closeStart}
            open={this.state.startCalendarOpen}
            targetEl={startDateButton}
            appendToBody>
            <SDPWrapper initialDate={this.state.startDate} onDateChange={this.onStartDateChanged}
              outsideRange={isOutsideRange} dayHighlighted={isDayHighlightedStart} booking={true}
            />
          </Popover>
          {
            this.state.allDay ? 
            <TimePicker use12Hours={this.use12Hours} format={this.format}
              value={moment('0:00', this.format)} disabled aria-label={checkInTimeLabel} /> :
            <TimePicker  use12Hours={this.use12Hours}  format={this.format}
              minuteStep = {5}
              showNow = {false}
              value = {startTime}
              onOpenChange={onOpenChange}
              onChange={this.onStartTimeChange}
              inputReadOnly={true}
              aria-label={checkInTimeLabel} />
          }
        </div>
        <div className={CSS.bookingFields}>{i18n.more.bookWorkspace.checkOut}</div>
        <div className={CSS.durationGroup}>
          <Popover
            closeOnSelect={false}
            onRequestClose={this.closeEnd}
            open={this.state.endCalendarOpen}
            targetEl={endDateButton}
            appendToBody>
            <SDPWrapper initialDate={this.state.endDate} onDateChange={this.onEndDateChanged}
              outsideRange={isOutsideRange} dayHighlighted={isDayHighlightedEnd} booking={true}
            />
          </Popover>
          {
            this.state.allDay ? 
            <TimePicker use12Hours={this.use12Hours} format={this.format}
              value={moment('23:59', this.format)} disabled aria-label={checkOutTimeLabel} /> :
            <TimePicker  use12Hours={this.use12Hours}  format={this.format}
              allowClear = {false}
              minuteStep = {5}
              showNow = {false}
              value = {endTime}
              onOpenChange={onOpenChange}
              onChange={this.onEndTimeChange}
              inputReadOnly={true}
              aria-label={checkOutTimeLabel} />
          }
        </div>
        <div className={CSS.bookingFields}>{i18n.more.bookWorkspace.spaceType} </div>
        <div className={CSS.bookingDetails}>{this.props.spaceType}</div>
        {this.props.areaName && 
          <div>
                <div className={CSS.bookingFields}>{i18n.more.bookWorkspace.area} </div>
                <div className={CSS.bookingDetails}>{this.props.areaName}</div>
          </div>
        }
        <br></br>
    </div>
        <div className={CSS.button}>
            <Button className= {CSS.confirmButton} type="button" onClick={this.confirmClicked}>{i18n.more.bookWorkspace.confirm}</Button>
        </div>
    </div>
    </div>
    )
  }

  togglePopoverStart = () => {
    this.setState({
      startCalendarOpen: !this.state.startCalendarOpen,
      endCalendarOpen: false
    })
  }

  togglePopoverEnd = () => {
    this.setState({
      endCalendarOpen: !this.state.endCalendarOpen,
      startCalendarOpen: false
    })
  }

  closeStart = () => {
    this.setState({
      startCalendarOpen: false
    })
  }

  closeEnd = () => {
    this.setState({
      endCalendarOpen: false
    })
  }

  
}

const mapStateToProps = (state) => {
  return {
    rdxStartDateSelected: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_STARTSELECTED),
    rdxEndDateSelected: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_ENDSELECTED),
    rdxStartTimeSelected: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_STARTSELECTED),
    rdxEndTimeSelected: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_ENDSELECTED),
    rdxAllDayChecked: Rdx.getValue(state, Rdx.Keys.BOOK_ALLDAY)
  }
}

export default connect(mapStateToProps)(BookingDetails);
